document.addEventListener("DOMContentLoaded", () => {
  const setAnnounceHeight = () => {
    const bar = document.querySelector(".announcement");
    const h = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--announcement-h", `${h}px`);
  };

  setAnnounceHeight();
  window.addEventListener("resize", setAnnounceHeight);

  // If your announcement rotates text, re-measure a bit later too
  setTimeout(setAnnounceHeight, 300);
  setTimeout(setAnnounceHeight, 1200);
});


